//componente per l'aggiunta file uno per volta
import React from 'react'
import { connect } from 'react-redux';
import plusimage from './plus.svg'
import {addLayerFile} from '../redux'
import { Trans } from 'react-i18next';
import AddLayerListFile from '../AddLayer/AddLayerListFile'


class ReactFileUpload extends React.Component {
  
  

  constructor(props) {
    super(props);
    this.state ={
        selectedFile: null
    }
   
  }
  onChangeHandler=event=>{
   
    this.setState({
        selectedFile: event.target.files[0],
        loaded: 0,
      })
      
  }

reset=()=> {
  
  this.props.addLayerFile({file: null,type: null})

}
fileUpload=()=>{
 try {
 
  this.props.addLayerFile({file: this.state.selectedFile,type: this.props.typeLayer.type})
  
} catch (error) {
  this.props.addLayerFile({file: this.state.selectedFile,type: "ShapeFile"})
  
} 

 

  
}
reset=()=> {
 
  this.props.addLayerFile({file : null,type: null})
  
}
 handleDragEnter = (event) => {

  
  event.preventDefault();
  event.stopPropagation();
  
};

 handleDragOver = (event) => {
  
  event.preventDefault();
  event.stopPropagation();
  event.dataTransfer.dropEffect = 'copy';
  
};
handlerDragStart = (event) =>{
  
  event.preventDefault();
  event.stopPropagation();
  
}
 handleDrop = (event) => {
   
  event.preventDefault();
  event.stopPropagation();
  let files = [...event.dataTransfer.files];
  this.setState({
    selectedFile:files[0],
    loaded: 0,
  })
};

  


  render() {
    
    return (
      <div>
        <div         
        onDragStart={this.handlerDragStart}      
        onDrop={this.handleDrop}
       onDragOver={this.handleDragOver}
       onDragEnter={this.handleDragEnter} >
          <label className={"dragDiv"} htmlFor="file-upload" ><Trans>TRASCINA O CLICCA PER AGGIUNGERE UN FILE</Trans>
          <img style={{width: '22px',height: '22px',position: 'relative',left: '20px',top:'8px'}} src={plusimage} alt="plus" ></img></label>
         <input style={{display:'none'}} id="file-upload" type="file" accept=".zip, .kml, .csv, .geojson, .kmz" name="file"  onChange={this.onChangeHandler}/>
      </div> 
      <div>
        <div className={"fileTesto"}> {this.state.selectedFile !== null ? this.state.selectedFile.name : null}</div>
      <button className={"aggiungiFileStyle"}  onClick={this.fileUpload}><Trans>Upload</Trans></button>
      <button className={"aggiungiResetStyle"} onClick={this.reset}>Reset</button>
      <AddLayerListFile></AddLayerListFile>
      </div>
      <div>
        
         
        </div> 
      
      </div> 
       
   )
  }
}


const mapStateToProps = state => {
  return {
      layerFile: state.layerFile,
      typeLayer: state.typeLayer.typeLayer
  }
}
const mapDispatchToProps = dispatch => {
  return {
    addLayerFile: (layerFile) => dispatch(addLayerFile(layerFile))
  }
}

export default connect(mapStateToProps,mapDispatchToProps) (ReactFileUpload);
 